document.addEventListener('DOMContentLoaded', function () {
  const recoverLink = document.querySelector('a[href="#recover"]');
  const cancelLink = document.querySelector('a[href="#login"]');
  const resetTitle = document.querySelector('.customer .section-title:nth-child(1)');
  const resetForm = document.querySelector('form[action="/account/recover"]');
  const loginTitle = document.querySelector('.customer .section-title:nth-child(3)');
  const loginForm = document.querySelector('#customer_login');

  if (resetTitle && resetForm) {
    // Hide reset section by default
    resetTitle.style.display = 'none';
    resetForm.style.display = 'none';
  }

  if (recoverLink) {
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (resetTitle && resetForm && loginTitle && loginForm) {
        resetTitle.style.display = 'block';
        resetForm.style.display = 'block';
        loginTitle.style.display = 'none';
        loginForm.style.display = 'none';
      }
    });
  }

  if (cancelLink) {
    cancelLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (resetTitle && resetForm && loginTitle && loginForm) {
        resetTitle.style.display = 'none';
        resetForm.style.display = 'none';
        loginTitle.style.display = 'block';
        loginForm.style.display = 'block';
      }
    });
  }
});






